<template>
  <div class="sold-out scroll-touch">
    <fixed-header title="商品已下架"></fixed-header>
    <div class="sold-out__main">
      <div class="sold-out__top">
        <img :src="bgImg">
      </div>
      <!--      <goods-demo></goods-demo>-->
    </div>
  </div>
</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
// import GoodsDemo from 'components/common/GoodsDemo';
import bgImg from 'assets/img/paidfail.png';

export default {
  components: {
    FixedHeader,
    // GoodsDemo
  },
  data() {
    return {
      bgImg,
    };
  },
};

</script>

<style lang="scss">
.sold-out {
  height: 100%;

  &__main {
    height: 100%;
  }

  &__top {
    height: 290px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 226px;
      height: 152px;
    }
  }
}

</style>
